module.exports = __webpack_public_path__ + "img/bbl.23ef91aa.svg";